import React, { useEffect, useState } from 'react';
import { requestPermission, getPermissionStatus, getNotifPrefs, saveNotifPrefs } from '../../services/notificationService';
import { useJarvisContext } from '../../context/JarvisContext';

// The app already had a full notification system (notificationService.js
// — session alerts, price alerts, daily recap reminder) but nothing ever
// proactively asked the browser for permission; it was buried behind a
// button on the Notifications tab of Settings, which most people never
// open. This surfaces the ask directly, once, the same pattern as
// InstallPWA. Stacked above that banner (bottom:172px vs its 100px) so
// both can be visible at once without overlapping.
const IS_ELECTRON = !!(window.electronAPI && window.electronAPI.isElectron);

export default function EnableNotifications() {
  const { state } = useJarvisContext();
  const onChatScreen = state.activeScreen === 'v5chat';
  // Same stacking-context reasoning as InstallPWA.jsx — see V5Shell.jsx.
  const drawerOpen = state.sidebarOpen;
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem('jarvis_notif_dismissed') === '1'; } catch { return false; }
  });

  useEffect(() => {
    if (IS_ELECTRON || dismissed) return;
    if (getPermissionStatus() !== 'default') return; // already granted/denied/unsupported — never re-ask
    const t = setTimeout(() => setVisible(true), 4000); // let the app settle first
    return () => clearTimeout(t);
  }, [dismissed]);

  if (IS_ELECTRON || dismissed || onChatScreen || drawerOpen || !visible) return null;

  const handleEnable = async () => {
    const result = await requestPermission();
    if (result === 'granted') {
      saveNotifPrefs({ ...getNotifPrefs(), enabled: true });
    }
    setVisible(false);
  };

  const handleDismiss = () => {
    setDismissed(true);
    setVisible(false);
    try { sessionStorage.setItem('jarvis_notif_dismissed', '1'); } catch { /* ignore */ }
  };

  return (
    <div style={{
      position: 'fixed', left: '12px', right: '12px', bottom: '172px', zIndex: 1500,
      background: '#111827', border: '1px solid #ffd700', borderRadius: '10px',
      padding: '12px 14px', display: 'flex', alignItems: 'center', gap: '10px',
      fontFamily: 'monospace', boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
    }}>
      <span style={{ fontSize: '20px' }}>🔔</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: '#e2e8f0', fontSize: '13px', fontWeight: '700' }}>Enable Notifications</div>
        <div style={{ color: '#94a3b8', fontSize: '11px' }}>Session alerts, price alerts, daily recap — tab उघडी असताना</div>
      </div>
      <button onClick={handleEnable} style={{
        background: '#ffd700', color: '#000', border: 'none', borderRadius: '6px',
        padding: '8px 14px', fontSize: '12px', fontWeight: '700', cursor: 'pointer',
        fontFamily: 'monospace', flexShrink: 0,
      }}>Enable</button>
      <button onClick={handleDismiss} aria-label="Dismiss" style={{
        background: 'transparent', color: '#94a3b8', border: 'none', fontSize: '16px',
        cursor: 'pointer', padding: '4px', flexShrink: 0,
      }}>✕</button>
    </div>
  );
}
